module.exports = "/assets/earth-poster-yellow.jpg?7z31aUX";